<div class="career form-sagro mb-footer">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner"></app-banner-header>
    </div>
    <div class="page-able mt-md-5 mt-4">
        <router-outlet></router-outlet>
    </div>
</div>

